// extracted by mini-css-extract-plugin
export default {"iconText":"styles_iconText__2fgyE","detail":"styles_detail__QoabB","text":"styles_text__lLLhi","info":"styles_info__Cqst2"};